import { useNavigate } from 'react-router-dom';
import type { Lobby } from '../types/game';
import { FaUsers } from 'react-icons/fa';
import { motion } from 'framer-motion';

interface LobbyListProps {
  lobbies: Lobby[];
}

export default function LobbyList({ lobbies }: LobbyListProps) {
  const navigate = useNavigate();

  if (lobbies.length === 0) {
    return <p className="text-center text-gray-400 mt-8">Aktuell sind keine Lobbys verfügbar. Erstelle eine neue!</p>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {lobbies.map((lobby) => (
            <motion.div
              key={lobby.id}
          className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl shadow-lg p-6 flex flex-col justify-between hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-1"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
            >
          <div>
            <h3 className="text-lg font-semibold mb-2">{lobby.hostName}'s Lobby</h3>
            <p className="text-sm text-gray-400 mb-4">Runde: {lobby.roundNumber}</p>
            <p className="text-sm text-gray-400 mb-4">Status: {lobby.gameState}</p>
            <div className="flex items-center text-sm text-gray-300">
              <FaUsers className="mr-2" />
              <span>
                Spieler: {lobby.players.length}
              </span>
                </div>
              </div>
          <button
            onClick={() => navigate(`/lobby/${lobby.id}`)}
            className="mt-4 w-full bg-green-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-green-700 transition-colors"
          >
            Beitreten
          </button>
          </motion.div>
      ))}
    </div>
  );
} 